<template>
	<div ref="img" class="image-box">
		
		<div id="target">
			<img ref="imginner" style="width:100%" :src="page.url" />

		</div>

	</div>
</template>

<script>
import store from "@/services/Store";
import $ from "jquery";
import heic2any from "heic2any";

export default {
	name: "ImageMedia",
	props: ["page", "chan"],
	data() {
		return {
			events: [],
			sizes: [0.5, 0.65, 0.8, 1, 1.2, 1.5, 1.8, 2],
			rotate: 0,
			invert: false,
			fileExt: this.page.text.split('.').pop(),
			page_url: this.page.url
			// page: this.page
		};
	},

	watch: {},

	created() {
		//Zoom
		var zoom = () => {
			this.updateWidth();
		};
		if (this.chan) {
			this.events.push({ key: "zoom-in", val: zoom });
			this.events.push({ key: "zoom-out", val: zoom });
			this.chan.$on("zoom-in", zoom);
			this.chan.$on("zoom-out", zoom);

			//Invert
			var invert = () => {
				var ele = $(this.$refs.imginner);
				this.invert = !this.invert;
				if (this.invert) {
					ele.css("filter", "invert(100%)");
				} else {
					ele.css("filter", "invert(0%)");
				}
			};
			this.events.push({ key: "invert", val: invert });
			this.chan.$on("invert", invert);

			//Rotate
			var rotate = () => {
				var ele = $(this.$refs.img);
				this.rotate += 90;

				let x = ele.width();
				let y = ele.height();
				let aspect = x / y;

				//This calculation can be simplified to (x / y) - (y /x)
				//but it makes way more sense to me this way
				let newY = x * aspect;
				let vPadPixels = newY - y;
				let vPadPercent = (vPadPixels / x) * 100;
				let pad = vPadPercent / 2;

				if (this.rotate % 180 == 0) {
					ele.css("transform", `rotate(${this.rotate}deg) scale(1)`);
					ele.parent().css("padding-top", "0");
					ele.parent().css("padding-bottom", "0");
				} else {
					ele.css("transform", `rotate(${this.rotate}deg) scale(${aspect})`);
					ele.parent().css("padding-top", `${pad}%`);
					ele.parent().css("padding-bottom", `${pad}%`);
				}
			};
			this.events.push({ key: "rotate", val: rotate });
			this.chan.$on("rotate", rotate);
		}
		//if HEIC ITEM: 


		if(this.fileExt == "HEIC" || this.fileExt == "heic"){
			console.log("the element is HEIC")
		fetch(this.page_url)
		.then((res) => res.blob())
		.then((blob) => heic2any({
			blob
		}))
		.then((conversionResult) => {
			var url = URL.createObjectURL(conversionResult);
			document.getElementById("target").innerHTML = `<a target="_blank" href="${url}"><img src="${url}"></a>`;
		})
		.catch((e) => {
			console.log(e);
		});
		}

	},

	mounted() {},
	destroyed() {
		var _this = this;
		_.each(this.events, e => {
			_this.chan.$off(e.key, e.val);
		});
	},

	methods: {
		updateWidth() {
			var zoom = store.get(this, "viewerScale");
			var size = this.sizes[zoom] || this.sizes[4];
			var targetWidth = 800 * size;
			console.log(targetWidth);

			$(this.$refs.img).css("width", targetWidth);
		}
	}
};
</script>

<style>
.image-box {
	margin-top: 20px;
	position: relative;
	margin-left: auto;
	margin-right: auto;
	/*min-height:1250px;*/
	/*width:1000px;*/
	/*font-size: 17pt;*/

	/*min-height:1000px;*/
	/* max-width: 800px; */
	min-width: 400px;
	font-size: 13pt;

	/*padding:80px;*/
	-webkit-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	-moz-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	background-color: white;
	color: black;
	font-family: "Times New Roman", Times, Georgia, serif;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/ImageMedia.vue